const excludedLayouts = ["HeroLeadSearch", "HeroLead", "LayoutForm"]


/* 
  Determines whether a dynamic divider should be rendered between two sections
  based on their themes and types.
*/
export const handleDynamicDivider = (
  index: any,
  item: any,
  pageContent: any,
) => {
  if (index + 1 < pageContent.sections.length) {
    let section1Theme = null
    let section2Theme = null
    if (excludedLayouts.includes(item.__typename)) {
      section1Theme = "do not"
    } else if (item.__typename == "LayoutSubjectSpotlight") {
      if (item?.spotlightImage?.image?.url) {
        section1Theme = "do not"
      } else {
        section1Theme = pageContent.sections[index].theme
      }
    } else {
      section1Theme = pageContent.sections[index].theme
    }
    if (item.__typename == "HeroLeadSearch" || item.__typename == "HeroLead") {
      // never put a divider here because hero lead is panels that vary.
      section2Theme = "no"
      // if the Subject Spotlight is the second thing, then we do want the divider with elegible layouts
    } else {
      section2Theme = pageContent.sections[index + 1].theme
    }
    if (section1Theme == section2Theme) {
      return true
    }
  }
  return false
}
